import useSWR, { preload } from 'swr';
import { useIsAuthenticated } from "@azure/msal-react";
import { httpResponseToJSON } from '../helpers/fetchHelpers';
import { getAuthenticatedHeaders, simpleFetcher } from './fetchHeaders';
import { logFailedRequestTiming, logRequestTiming } from './insightsHelper';

export const useFamilyNameList = (includeNoDocFamilies) => {
    const startTime = performance.now(); // Start timing
    const apiPath = `/document/FamilyNames${includeNoDocFamilies ? '?includeNoDocFamilies=true' : ''}`;
    const { data, error, isValidating, mutate } = useSWR(
        apiPath,
        () => getAuthenticatedHeaders().then((headers) => {
            return fetch(apiPath, { headers })
                .then(response => httpResponseToJSON(response, 'Error loading family name list'/*, showError*/))
        }),
        {
            ...swrConfig,
            onSuccess: (_data, key) => {
                const endTime = performance.now(); // End timing
                logRequestTiming(key, Math.round(endTime - startTime));
            },
            onError: (_error, key) => {
                const endTime = performance.now(); // End timing
                logFailedRequestTiming(key, Math.round(endTime - startTime));
            }
        });

    const familyNames = data || [];

    return { familyNames, error, isValidating, mutate };
};

export const useLanguageList = () => {
    const startTime = performance.now(); // Start timing
    const isAuthenticated = useIsAuthenticated();
    const { data, error, isValidating, isLoading, mutate } = useSWR(
        isAuthenticated ? '/document/Languages' : null,
        () => getAuthenticatedHeaders().then((headers) => {
            return fetch('/document/Languages', { headers })
                .then(response => httpResponseToJSON(response, 'Error loading language list'/*, showError*/))
        }),
        {
            ...swrConfig,
            onSuccess: (_data, key) => {
                const endTime = performance.now(); // End timing
                logRequestTiming(key, Math.round(endTime - startTime));
            },
            onError: (_error, key) => {
                const endTime = performance.now(); // End timing
                logFailedRequestTiming(key, Math.round(endTime - startTime));
            }
        });

    const languages = data || [];

    return { languages, error, isValidating, isLoading, mutate };
};

export const preloadDocumentTypeList = () => {
    preload('/document/DocumentTypes', simpleFetcher);
};

export const useDocumentTypeList = () => {
    const startTime = performance.now(); // Start timing
    const { data, error, isValidating, mutate } = useSWR(
        '/document/DocumentTypes',
        simpleFetcher,
        {
            ...swrConfig,
            onSuccess: (_data, key) => {
                const endTime = performance.now(); // End timing
                logRequestTiming(key, Math.round(endTime - startTime));
            },
            onError: (_error, key) => {
                const endTime = performance.now(); // End timing
                logFailedRequestTiming(key, Math.round(endTime - startTime));
            }
        });

    const documentTypes = data || [];

    return { documentTypes, error, isValidating, mutate };
};

export const useBusinessGroupList = () => {
    const startTime = performance.now(); // Start timing
    const { data, error, isValidating, mutate } = useSWR(
        '/document/BusinessGroups',
        () => getAuthenticatedHeaders().then((headers) => {
            return fetch('/document/BusinessGroups', { headers })
                .then(response => httpResponseToJSON(response, 'Error loading business group list'/*, showError*/))
        }),
        {
            ...swrConfig,
            onSuccess: (_data, key) => {
                const endTime = performance.now(); // End timing
                logRequestTiming(key, Math.round(endTime - startTime));
            },
            onError: (_error, key) => {
                const endTime = performance.now(); // End timing
                logFailedRequestTiming(key, Math.round(endTime - startTime));
            }
        });

    const businessGroups = data || [];

    return { businessGroups, error, isValidating, mutate };
};

const swrConfig = {
    revalidateOnFocus: false,
    onErrorRetry: (error, key, config, revalidate, { retryCount }) => {
        // Never retry on 4XX error.
        if (error.status >= 400 && error.status < 500) return;

        //   // Never retry for a specific key.
        //   if (key === '/api/user') return

        // Only retry up to 1 times.
        if (retryCount > 1) return;

        // Retry after 1 seconds.
        setTimeout(() => { revalidate({ retryCount }); }, 1000)
    }
};